import { Infer, object, string } from "superstruct";
import { InjectionToken } from "tsyringe";

export const MediaFeedApplicationConfigSchema = object({
    mediaFeedPageWidgetPlaceholderSelector: string(),
    mediaFeedHomeWidgetPlaceholderSelector: string(),
    mediaFeedProductWidgetPlaceholderSelector: string(),
});

export type MediaFeedApplicationConfigInterface = Infer<
    typeof MediaFeedApplicationConfigSchema
>;

export const MediaFeedApplicationConfigToken = Symbol(
    "MediaFeedApplicationConfigToken"
) as InjectionToken<MediaFeedApplicationConfigInterface>;
